<template>
  <div id="bsModalSquareResult" aria-labelledby="bsModalLabel" class="modal fade" data-backdrop="static"
       data-keyboard="false" data-toggle="modal"
       role="dialog" tabindex="-1" @click="clickOverlay()">
    <div class="modal-dialog" role="document" @click.stop>
      <div class="modal-content">
        <div class="modal-header">
          <button aria-label="Close" class="close" type="button" @click="close()">
            <span aria-hidden="true">&times;</span>
          </button>
          <h4 id="bsModalLabel" class="modal-title">{{ title }}</h4>
        </div>
        <div class="modal-body">
          <template v-if="data">
            <div class="row">
              <div class="col-md-3">ID:</div>
              <div class="col-md-9">
                {{ data.id }}
              </div>
            </div>
            <div class="row">
              <div class="col-md-3">Amount:</div>
              <div class="col-md-9">{{ data.totalMoney.amount / 100 + ' ' + data.totalMoney.currency }}</div>
            </div>
            <div class="row">
              <div class="col-md-3">Approved Amount:</div>
              <div class="col-md-9">{{ data.approvedMoney.amount / 100 + ' ' + data.approvedMoney.currency }}</div>
            </div>
            <div class="row">
              <div class="col-md-3">Status:</div>
              <div class="col-md-9">{{ data.status }}</div>
            </div>
            <div class="row">
              <div class="col-md-3">Note:</div>
              <div class="col-md-9">{{ data.note }}</div>
            </div>
            <div class="row">
              <div class="col-md-3">Receipt:</div>
              <div class="col-md-9">
                <a :href="data.receiptUrl" target="_blank">View Receipt</a>
              </div>
            </div>
          </template>
          <template v-else>
            <p class="mb-0">
              {{ message ? message : 'No record found!' }}
            </p>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'SquareResultModal',
  data() {
    return {
      title: '',
      data: null,
      message: ''
    }
  },
  computed: {
    ...mapGetters([
      'currentUser'
    ])
  },
  methods: {
    clickOverlay: function() {
      // Hide modal
      this.close()
    },
    close() {
      $('#bsModalSquareResult').modal('hide')
    }
  },
  mounted() {
    this.$bus.$on('square-result-modal', (args) => {
      this.title = args.title
      this.data = args.data
      this.message = args.message
      $('#bsModalSquareResult').modal('show')
    })
  }
}
</script>

<style scoped></style>
